var _path;
import * as React from "react";
function SvgBookmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 36V7a3 3 0 013-3h18a3 3 0 013 3v29l-12-7-12 7z"
  })));
}
export default SvgBookmarkFill;